module.exports = __webpack_public_path__ + "img/idriss_h.9fffffc4.png";